export default [  
  {
    familyID: "3291",
    location: "Boulder, CO",
    startDate: "Truly Flexible for the right candidate",
    schedule: "M-F",
    hours: "20-25 hours /week 1 or 2pm -6pm",
    pay: "$28-32/hour",
    placementLength: "Permanent Long Term",
    nKids: "Afterschool care 5 yo and 1.5 yo girls",
    familydescription:
      "Family of 4",
    jobDescription: `Please email myboulderbabysitter@gmail.com for details`,
    postedDate: "May 15th, 2026"
  },
  {
    familyID: "1850",
    location: "North Thorton/Todd Creek, CO",
    startDate: "October 1",
    schedule: "3 half days, or 2 full days per week, flexible",
    hours: "flexible",
    pay: "$30-35+/hour",
    placementLength: "Temporary, can extend fulltime and long term for the right candidate",
    nKids: "1",
    familydescription:
      "Family of 3 plus cat",
    jobDescription: `Please email myboulderbabysitter@gmail.com for details`,
    postedDate: "Aug 1, 2026"
  },
  {
    familyID: "4222",
    location: "Louisville, CO",
    startDate: "Sept 7th, 2026",
    schedule: "2-3 overnights per week",
    hours: "20-30 per week",
    pay: "$35-45/hour",
    placementLength: "6-8 week commitment, longer for the right fit",
    nKids: "1 month old baby ",
    familydescription:
      "Family of 3, 4 shiba inu dogs",
    jobDescription: `Please email myboulderbabysitter@gmail.com for details`,
    postedDate: "Aug 27, 2026"
  }
];
